export const MAX_SESSION_DURATION_MS = 4 * 60 * 60 * 1000; // 4 hours
export const SESSION_INACTIVITY_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes

export const SESSION_START_NAME = "Session Start";
export const SESSION_END_NAME = "Session End";
